/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

const CorrelationId = {
  SelectCompanyContainer: 'SelectCompanyContainer'
};

export {
  CorrelationId
};
